const isDefined = v => v !== undefined && v !== null;

export const createIterArray = size => {
	const _size = isDefined(size) ? size : 0;
	return new Array(_size + 1).join('0').split('');
};

export default createIterArray;
